import React from 'react';
import { Modal } from 'react-bootstrap';
import closeIcon from '../../images/popups/upload/closeicon.png';
import '../../scss/popups/delete_user.scss';

function DeleteUser({show, handleClose, deleteApiCall, type, enable}) {
    return (
        <>
            <Modal
                show={show}
                onHide={handleClose} className='delete-user-popup'
                centered>
                <Modal.Body className='delete-user-body'>
                    <div className='close-icon'>
                        <img src={closeIcon} onClick={handleClose}/>
                    </div>
                    {type == "delete" ? <div className='delete-popup-header'>Confirm Delete</div> : 
                    <div className='delete-popup-header'>Confirm Suspend</div>}
                    {type == "delete" ? <div className='delete-popup-subheader'>Are you sure you want to delete this user?</div> : 
                    <div className='delete-popup-subheader'>Are you sure you want to suspend this user?</div>}
                    <div className='delete-button'>
                        {type == "delete" ? <button  disabled={enable ? false : true} className={enable ? 'add-button enable' : 'add-button disable'} onClick={deleteApiCall}>Delete</button> : 
                        <button onClick={deleteApiCall}>Suspend</button>}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default DeleteUser;